{
  "it": {
    "lead": {
      "actions": {
        "add_company": "Aggiungi azienda",
        "add_lead": "Aggiungi lead",
        "new": "Lead"
      },
      "attributes": {
        "address": "Indirizzo",
        "birth_date": "Data di nascita",
        "categories": {
          "enduser": "Acquirente occupante",
          "investor": "Investitore"
        },
        "category": "Tipo di lead",
        "company_name": "Nome azienda",
        "company_vat": "Partita IVA",
        "email_address": "Email",
        "first_name": "Nome",
        "iban": "IBAN",
        "internal_note": "Nota interna",
        "language": "Lingua",
        "last_name": "Cognome",
        "phone_landline": "Numero fisso",
        "phone_mobile": "Numero di cellulare",
        "status": "Stato"
      },
      "labels": {
        "detailed_information": "Inserisci informazioni dettagliate",
        "lead": "Lead"
      },
      "validation": {
        "needFirstName": "Nome obbligatorio",
        "needLastName": "Cognome obbligatorio"
      }
    }
  }
}
